// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"Y_-z","inlineTitle":"Z_-z","sponsoredAdsWrapper":"__-z","marketplaceRecosWrapper":"aaa-z","brandShopTheLookWrapper":"baa-z"};